export const normalizeImageQualityValue = (value: unknown): string => {
    if (typeof value !== 'string') return ''
    return value.trim().toLowerCase()
}

export const getModelQualityList = (model: any): string[] => {
    const raw = Array.isArray(model?.quality) ? model.quality : []
    const seen = new Set<string>()
    const result: string[] = []

    for (const item of raw) {
        const normalized = normalizeImageQualityValue(item)
        if (!normalized || seen.has(normalized)) continue
        seen.add(normalized)
        result.push(normalized)
    }

    return result
}

export const intersectModelQualityLists = (models: any[]): string[] => {
    if (!Array.isArray(models) || models.length === 0) return []

    const lists = models.map(getModelQualityList)
    if (lists.some(list => list.length === 0)) return []

    const [first, ...rest] = lists
    if (!first) return []

    return first.filter(item => rest.every(list => list.includes(item)))
}

export const getDefaultImageQualityValue = (options: string[]): string => {
    if (!Array.isArray(options) || options.length === 0) return ''
    return options.includes('high') ? 'high' : options[0] || ''
}

export const getImageQualityTranslationKey = (value: string): string => {
    switch (normalizeImageQualityValue(value)) {
        case 'low':
            return 'tools.qualityLow'
        case 'medium':
            return 'tools.qualityMedium'
        case 'high':
            return 'tools.qualityHigh'
        case 'xhigh':
            return 'gptImageOptions.quality.xhigh'
        case 'max':
            return 'gptImageOptions.quality.max'
        default:
            return ''
    }
}

export const pickImageQualityValue = (...values: unknown[]): string => {
    for (const value of values) {
        const normalized = normalizeImageQualityValue(value)
        if (normalized) return normalized
    }
    return ''
}
